import MicroModal from "micromodal";
import Swiper from "swiper/bundle";
import $ from "jquery";

$("#login").on("click", function (e) {
  e.preventDefault();
  window.location.href = "./menu.html";
});
$("#pw-open").on("click", function () {
  const pw = $("#password");
  if (pw.attr("type") === "password") {
    pw.attr("type", "text");
  } else {
    pw.attr("type", "password");
  }
});
$("#sp-btn").on("click", function () {
  if ($("#sp-menu").hasClass("active")) {
    $(this).removeClass("active");
    $("#sp-menu").removeClass("active");
  } else {
    $(this).addClass("active");
    $("#sp-menu").addClass("active");
  }
});
$("select").on("change", function () {
  if ($(this).val() !== "") {
    $(this).parent().addClass("active");
  } else {
    $(this).parent().removeClass("active");
  }
});
$(".movie-open").on("click", function () {
  const target = $(this).parents(".movies__item").find(".movies__item-body");
  if (target.hasClass("hide")) {
    target.removeClass("hide");
    $(this).removeClass("btn--green").addClass("btn--gray").text("ー");
  } else {
    target.addClass("hide");
    $(this).removeClass("btn--gray").addClass("btn--green").text("＋");
  }
});
$('input[name="video"]').click(function () {
  if ($('input[name="video"]:checked').val() === "ondemand") {
    $("#video-upload").removeClass("hide");
  } else {
    $("#video-upload").addClass("hide");
  }
});
$('.submit__lock').attr('type', 'button');
$('.submit__lock').click(function () {
    $(this).prop('disabled', true);
    if ($(this).data('ajax') === 'true') {
        return;
    }
    $(this).closest('form').submit();
});
$(".enter__lock").keypress(function(e) {
    if ((e.which && e.which === 13) ||
        (e.keyCode && e.keyCode === 13)) {
        return false;
    } else {
        return true;
    }
});

$('.select__btn').on('click', function () {
    if ($(this).hasClass('btn--blue')) {
        $(this)
            .removeClass('btn--blue')
            .addClass('btn--grey');
    } else {
        $(this)
            .removeClass('btn--grey')
            .addClass('btn--blue');
    }
})

$('.selected__btn').on('click', function () {
    let type = $(this).data('type');
    $('#' + type + '-container').empty();
    $('#' + type + "-list .select__btn").each(function () {
        if ($(this).hasClass('btn--grey')) {
            let elem = $('#' + type + '-tpl').clone();
            let id = $(this).data('id');
            elem.show();
            elem.removeAttr('id');
            elem.find('.item__name').html($(this).data('name'));
            elem.find('.selected-ids').val(id)
            if (type === 'product') {
                elem.find('.item__code').html($(this).data('code'));
                elem.find('.item__image img').attr('src', '').attr('src', $(this).data('image'));
            }
            elem.find('.item__btn').on('click', function () {
                $(this).closest('.item').remove();
                $('#' + type + '-btn-' + id)
                    .removeClass('btn--grey')
                    .addClass('btn--blue');
                if ($('#' + type + "-container .item").length === 0) {
                    $('#' + type + '-area').hide();
                }
            });
            $('#' + type + '-container').append(elem);
            $('#' + type + '-area').show();
        }
    });
});
if (window.hasReservationStores) {
    $('#store_save_btn').trigger('click');
}

if (window.hasReservationProducts) {
    $('#product_save_btn').trigger('click');
}

$('.popup-mail').on('click', function () {
    let reservation = reservationMap['id_' + $(this).data('reservation-id')];
    $('#reservation-title').html(reservation.title);
    $('#reservation-datetime').html(reservation.datetime_display);
    $('#reservation-container').empty();
    console.log('reservation',reservation);
    for (let i = 0; i < reservation.reservationStores.length; i++) {
        let reservationStore = reservation.reservationStores[i];
        let qrcode = reservation.qrcodes[i];
        $('#reservation-container').append(
            $('<tr>').append(
                $('<td>').addClass('td-btn').html(
                    '<label>' +
                    '<input type="checkbox" name="reservation_store_ids[]" class="mr-15" ' +
                           'value="' + reservationStore.id + '">' +
                    reservationStore.store_name + '<br>' +
                    reservationStore.url +
                    '</label>'
                )
            ).append(
                $('<td>').addClass('td-btn').html(qrcode)
            )
        )
    }
});

const select_item = (reservationProductId) => {
    $('#r--modal1').html($('#r--modal1-tpl-' + reservationProductId).html())
    $('#r--modal2').html($('#r--modal2-tpl-' + reservationProductId).html())
    $('[name="product_id"]').val($('#r--product_id-' + reservationProductId).html())
    new Swiper("#r--modal1 .modal-slider", {
        loop: true,
        spaceBetween: 15,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            100: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 4,
            },
        }
    });
}

$('.r__btn').on('click', function () {
    select_item($(this).data('id'));
});

$('.o__btn').on('click', function () {
    const orderId = $(this).data('id');
    $('#o--modal').html($('#o--modal-tpl-' + orderId).html())
});

$('.delete-image__btn').on('click', function () {
    const i = $(this).data('i')
    $('#path_' + i).val('');
    $('#img_' + i).remove();
    $(this).remove();
});

$('#store-filter').on('keyup', function () {
    const keyword = $(this).val();
    $('#modal-1-content .td-name') .each(function () {
        if ($(this).html().indexOf(keyword) !== -1)  {
            $(this).closest('tr').show();
        } else {
            $(this).closest('tr').hide();
        }
    });
});

let counter = 0;

window.updateOrder = () => {
    $.ajax({
        type: "get",
        url: RESERVATION_STATUS_URL,
    }).done(function(data){
        for (let i = 0; i < data.status.length; i++) {
            const record = data.status[i];
            $('#product__sum' + record.product_id).html(record.sum_quantity);
        }
    }).fail(function(){
        alert('注文処理が失敗しました。')
    });
}

window.addCommentItem = (data) => {
    let item = $('#comment-item-tpl').clone();
    item.attr('id', 'comment-item---' + counter++);
    item.find('.comment-item__name').html(data.userName);
    item.find('.comment-item__comment').html(data.comment);
    item.find('.comment-item__thumb img').attr('src', data.thumb);
    item.show();

    $('#comment-list-container').append(item);
    document.getElementById('live--comment--scroll-area').scrollTop =
        document.getElementById('live--comment--scroll-area').scrollHeight;
};

if (typeof RESERVATION_STATUS_URL !== 'undefined') {
    updateOrder();
}

const show_validation_messages = (a) => {
    let msg = [];
    for (let key in a.responseJSON.errors) {
        let arr = a.responseJSON.errors[key];
        if (Array.isArray(arr)) {
            for (let i = 0; i < arr.length; i++) {
                let val = arr[i];
                msg.push('<li>' + val + '</li>')
            }
        }
    }
    if (msg.length > 0) {
        if ($('#error-area').length > 0) {
            $('#error-area').append(
                $('<ul>').html(msg.join("\n"))
            );
        } else if ($('.error-messages').length > 0) {
            $('.error-messages').append(
                $('<ul>').html(msg.join("\n"))
            );
        }
    }
};

$('#order__btn').on('click', function () {
    if (!$.isNumeric($('#quantity').val())) {
        alert('数値を入力してください。');
        return;
    }
    $.ajax({
        type: "post",
        url: $('#order__form').attr('action'),
        data: $('#order__form').serialize(),
    }).done(function(data){
        $('#order_close__btn').trigger('click');
        $('#quantity').val('')
        $('#order-list').html(data);
        manager.send(JSON.stringify({'type':'function', 'name': 'updateOrder'}));
    }).fail(function(a){
        if (a.status !== 422) {
            alert('注文処理が失敗しました。');
            return;
        }
        show_validation_messages(a);
    }).always(function () {
        $('#order__btn').prop('disabled', false);
    });
})

$('.delete__btn').on('click', function () {
    if (!confirm("削除します。よろしいですか？")) {
        return false;
    }
    $('#delete--form').submit();
    return true;
});

$('.del-img-btn').on('click', function () {
    $('#del-img-' + $(this).data('id')).val($(this).data('id'));
    $('#img_' + $(this).data('index')).attr('src', '').hide();
    $(this).hide();
});

// $('#reservation__btn').on('click', function () {
//     $.ajax({
//         type: "post",
//         url: $('#reservation__form').attr('action'),
//         data: $('#reservation__form').serialize(),
//     }).done(function(data){
//         if ('reservation' in data &&
//                 'is_created_channel' in data.reservation &&
//                 data.reservation.is_created_channel === 1) {
//             return;
//         } else {
//             $('[name="id"]').val(data.reservation.id);
//             createChannel(data.reservation.id);
//         }
//     }).fail(function(a,b,c,d){
//         if (a.status !== 422) {
//             alert('予約登録が失敗しました。');
//             return;
//         }
//         show_validation_messages(a);
//     });
// });

const createChannel = (reservationId) => {
    try {
        createSignalingChannel(
            AWS_ACCESS_KEY_ID,
            AWS_SECRET_ACCESS_KEY,
            AWS_REGION,
            AWS_CHANNEL + reservationId
        );
    } catch (e) {
        alert('チャンネル作成が失敗しました。');
        return;
    }
    $.ajax({
        type: "post",
        url: $('#set-is-created-channel__form').attr('action'),
        data: $('#set-is-created-channel__form').serialize(),
    }).done(function(data){
        console.log('転送処理はコメントアウトしています。');
        //location.href = RESERVATION_COMPLETE_URL;
    }).fail(function(){
        alert('チャンネル作成フラグ設定処理が失敗しました。')
    });
};

const deleteChannel = async (channel) => {
    if (!confirm("配信を終了すると、再度配信できなくなります。\nよろしいですか？")) {
        return;
    }

    info.stopMaster();

    await deleteIVSChannel(
        AWS_ACCESS_KEY_ID,
        AWS_SECRET_ACCESS_KEY,
        AWS_REGION,
        channel
    );
    await deleteIVSChannel(
        AWS_ACCESS_KEY_ID,
        AWS_SECRET_ACCESS_KEY,
        AWS_REGION,
        channel + '_disp'
    );

    $.ajax({
        type: "post",
        url: $('#delete__form').attr('action'),
        data: $('#delete__form').serialize(),
    }).done(function(data){
        location.href = RESERVATION_COMPLETE_URL;
    }).fail(function(){
        alert('チャンネル作成フラグ設定処理が失敗しました。')
    });
};

$('.start-live-btn').on('click', function () {
    $('#live-controls-form').attr('action', $(this).data('action')).submit();
});

$('#all-check').on('click', function () {
    $('input[name="reservation_store_ids\[\]"]').prop('checked', $(this).is(':checked'));
});

$('#send-mail-btn').on('click', function () {
    $('#body-required').hide();
    if (!$('#body-text').val() || $('#body-text').val() == '') {
        $('#body-required').show();
        return;
    }
    $.ajax({
        type: "post",
        url: $('#send-mail-form').attr('action'),
        data: $('#send-mail-form').serialize(),
    }).done(function (data) {
        $('[name="body"]').val('');

        $('#all-check').prop('checked', false);
        MicroModal.close('modal-3');
        console.log(data)
    }).fail(function () {
        alert('メール送信に失敗しました。')
    });
});

$('#reservation_done__btn').on('click', function () {
    deleteChannel($(this).data('id'));
})

if ($('[name="area_id"]').val() !== '') {
    $('[name="area_id"]').trigger('change')
}

if ($('[name="order"]').val() !== '') {
    $('[name="order"]').trigger('change')
}

$('[name="order"]').change(function () {
    $(this).closest('form').submit();
});

MicroModal.init({
    disableScroll: true
});

const swiperSlides = document.getElementsByClassName("swiper-slide");
const breakPoint = 992;
let itemSlider;
let itemSliderBool;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      itemSliderBool = false;
    } else {
      createItemSlider();
      itemSliderBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && itemSlider && itemSliderBool) {
      itemSlider.destroy(false, true);
      itemSliderBool = false;
    } else if (breakPoint >= window.innerWidth && itemSlider && !itemSliderBool) {
      createItemSlider();
      itemSliderBool = true;
    }
  },
  false
);

const createItemSlider = () => {
  itemSlider = new Swiper("#item-area .items-slider", {
    loop: true,
    spaceBetween: 15,
    navigation: {
      nextEl: ".items-swiper-button-next",
      prevEl: ".items-swiper-button-prev",
    },
    breakpoints: {
      992: {
        enabled: false,
      },
    },
    on: {
      click: function () {
          const id = $(this.clickedSlide).data('id');
          select_item(id);
          MicroModal.show('modal-1');
      },
    },
  });
};

const modalSlider = new Swiper(".modal-slider", {
  loop: true,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
      576: {
          slidesPerView: 2,
      },
    992: {
      slidesPerView: 4,
    },
  },
});
